export default "{\n    \"defaultSubmitLabel\": \"Save\"\n}\n"